import { createReducer, on } from "@ngrx/store";
import * as Actions from "./actions";
import { WearingPartCategoryStateInterface } from "src/app/devices/models/wearingPartCategoryStateInterface";

export const initialState: WearingPartCategoryStateInterface = {
    isLoading: false,
    wearingPartCategories: [],
    error: null,
};

export const wearingPartCategoriesReducers = createReducer(
    initialState, 

    // Get Wearing Part Categories
    on(Actions.getWearingPartCategories, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.getWearingPartCategoriesSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        wearingPartCategories: action.wearingPartCategories.slice().sort((a, b) => a.name.localeCompare(b.name))
    })),
    on(Actions.getWearingPartCategoriesFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Create Wearing Part Category
    on(Actions.createWearingPartCategory, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.createWearingPartCategorySuccess, (state, action) => ({
        ...state, 
        isLoading: false,
        wearingPartCategories: [...state.wearingPartCategories, action.wearingPartCategory].sort((a, b) => a.name.localeCompare(b.name))
    })),
    on(Actions.createWearingPartCategoryFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Update Wearing Part Category
    on(Actions.updateWearingPartCategory, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.updateWearingPartCategorySuccess, (state, action) => {
        const updatedCategoryIndex = state.wearingPartCategories.findIndex(category => category.id === action.wearingPartCategory.id);
        
        if (updatedCategoryIndex === -1) {
            return state; // If category not found, return current state
        }

        const updatedCategories = [...state.wearingPartCategories];
        updatedCategories[updatedCategoryIndex] = action.wearingPartCategory;

        return {
            ...state,
            isLoading: false,
            wearingPartCategories: updatedCategories.sort((a, b) => a.name.localeCompare(b.name))
        };
    }),
    on(Actions.updateWearingPartCategoryFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // Delete Wearing Part Category
    on(Actions.deleteWearingPartCategory, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(Actions.deleteWearingPartCategorySuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        wearingPartCategories: state.wearingPartCategories.filter(category => category.id !== action.id)
      })),
    on(Actions.deleteWearingPartCategoryFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),
);